import { Reveal } from "../Reveal";

const chapters = [
  { n: "01", title: "Clean, detailed parts", text: "Every section is mapped with intention — crisp lines that make the whole style look expensive." },
  { n: "02", title: "Protective styling", text: "Styles designed to protect your natural hair and edges while you grow and glow." },
  { n: "03", title: "Hair-included options", text: "Select styles include quality braiding hair, so you can just show up and sit pretty." },
  { n: "04", title: "Personalized looks", text: "Bring your inspiration — every look is tailored to your face, your hair, your vibe." },
  { n: "05", title: "Hampton, Virginia", text: "A private, comfortable appointment experience in the heart of the 757." },
  { n: "06", title: "Easy online booking", text: "Browse, pick your style, and request your appointment in minutes — right from your phone." },
];

export const WhyYaya = () => (
  <section className="px-5 py-16 md:py-28" data-testid="why-yaya">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mb-14 max-w-xl">
        <p className="font-script text-3xl text-hotpink">the Yaya difference</p>
        <h2 className="mt-2 font-serif text-4xl md:text-5xl">
          Why Book With Yaya
        </h2>
      </Reveal>

      <div className="grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={(i % 3) * 0.08} className="h-full">
            <div className="flex h-full flex-col gap-4 bg-ink p-8 transition-colors duration-500 hover:bg-coal">
              <span className="font-serif text-5xl font-bold text-hotpink/35">
                {c.n}
              </span>
              <h3 className="text-sm font-bold uppercase tracking-[0.2em]">
                {c.title}
              </h3>
              <p className="text-sm leading-relaxed text-white/50">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

